/**
 * Variant Stock Indicator for Chair Dinkum
 * Adds "Pre-order" or "Available" text below base colour buttons.
 * Hides base buttons that don't exist for the selected colour.
 * Works with Impulse theme's variant button selector.
 *
 * When data-hide-oos="true" is set on the product section:
 * - Out-of-stock colour swatches are hidden entirely
 * - Out-of-stock base options are hidden entirely
 * - On page load, auto-selects the first in-stock colour if the default is OOS
 * This is used on HÅG Capisco pages only.
 */
(function() {
  'use strict';
  var PREORDER_TEXT = 'Pre-order';
  var AVAILABLE_TEXT = 'Available';
  var BADGE_CLASS = 'cd-preorder-badge';

  // Inject styles
  var style = document.createElement('style');
  style.textContent = [
    '.' + BADGE_CLASS + ' { display: block; text-align: center; font-size: 0.75rem; margin-top: 4px; font-weight: 500; }',
    '.' + BADGE_CLASS + '--available { color: #2e7d32; }',
    '.' + BADGE_CLASS + '--preorder { color: #c1553b; }'
  ].join(' ');
  document.head.appendChild(style);

  function init() {
    // Find the product section
    var section = document.querySelector('[data-section-type="product"]');
    if (!section) return;

    // Check if this page is in "hide out-of-stock" mode (Capisco pages)
    var hideOos = section.getAttribute('data-hide-oos') === 'true';

    // Get variant data from the textarea
    var textarea = section.querySelector('textarea[data-variant-json]');
    if (!textarea) return;
    var variants;
    try {
      variants = JSON.parse(textarea.value);
    } catch(e) { return; }
    if (!variants || !variants.length) return;

    // PDP2: an explicit, valid ?variant= is a deliberate deep link (e.g. a pre-order colour). Keep it visible and selected.
    var explicitVariant = null;
    try {
      var explicitId = new URLSearchParams(window.location.search).get('variant');
      if (explicitId) {
        explicitVariant = variants.find(function(vv) { return String(vv.id) === String(explicitId); }) || null;
      }
    } catch(e) {}

    // Determine if this product has 2 options (colour + base) or 1 option
    var hasTwoOptions = variants[0].option2 != null;

    if (!hasTwoOptions) {
      // Single-option product: hide out-of-stock options if hideOos is true
      if (!hideOos) return;
      var fieldset = section.querySelector('fieldset[data-index="option1"]');
      if (!fieldset) return;
      var inputDivs = fieldset.querySelectorAll('.variant-input');
      inputDivs.forEach(function(inputDiv) {
        var input = inputDiv.querySelector('input[type="radio"]');
        if (!input) return;
        var v = variants.find(function(vv) { return vv.option1 === input.value; });
        if (explicitVariant && explicitVariant.option1 === input.value) return;
        if (v && (v.inventory_quantity || 0) <= 0) {
          inputDiv.style.display = 'none';
        }
      });
      return;
    }

    // Build lookup: { option1Value: { option2Value: inventory_quantity } }
    var stockMap = {};
    variants.forEach(function(v) {
      var colour = v.option1;
      var base = v.option2;
      if (!stockMap[colour]) stockMap[colour] = {};
      var existing = stockMap[colour][base];
      var qty = v.inventory_quantity || 0;
      if (existing === undefined || qty > existing) {
        stockMap[colour][base] = qty;
      }
    });

    // Find the colour fieldset (option1) and base fieldset (option2)
    var colourFieldset = section.querySelector('fieldset[data-index="option1"]');
    var baseFieldset = section.querySelector('fieldset[data-index="option2"]');
    if (!colourFieldset || !baseFieldset) return;

    // Helper: get currently selected colour value
    function getSelectedColour() {
      var checked = colourFieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    }

    // Helper: does a colour have any in-stock base?
    function colourHasStock(colourValue) {
      var bases = stockMap[colourValue] || {};
      return Object.keys(bases).some(function(base) {
        return bases[base] > 0;
      });
    }

    // Hide out-of-stock colour swatches (option1) when hideOos is true
    function updateColourVisibility() {
      if (!hideOos) return;
      var colourInputs = colourFieldset.querySelectorAll('.variant-input');
      colourInputs.forEach(function(inputDiv) {
        var input = inputDiv.querySelector('input[type="radio"]');
        if (!input) return;
        var colourValue = input.value;
        if (!colourHasStock(colourValue) && !(explicitVariant && explicitVariant.option1 === colourValue)) {
          inputDiv.style.display = 'none';
        } else {
          inputDiv.style.display = '';
        }
      });
    }

    // Auto-select the first in-stock colour if the current default has no stock
    function autoSelectFirstInStockColour() {
      if (!hideOos) return;
      if (explicitVariant) return; // PDP2: respect the deep-linked variant
      var selectedColour = getSelectedColour();
      if (selectedColour && colourHasStock(selectedColour)) return; // current colour is fine

      // Find the first visible colour input that has stock
      var colourInputs = colourFieldset.querySelectorAll('.variant-input');
      for (var i = 0; i < colourInputs.length; i++) {
        var inputDiv = colourInputs[i];
        // Skip already-hidden ones
        if (inputDiv.style.display === 'none') continue;
        var input = inputDiv.querySelector('input[type="radio"]');
        if (!input) continue;
        if (colourHasStock(input.value)) {
          // Click the label to trigger Shopify's native variant change logic
          var label = inputDiv.querySelector('label');
          if (label) {
            label.click();
          } else {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          break;
        }
      }
    }

    // Update base buttons: hide non-existent combos, and hide/badge out-of-stock ones
    function updateBaseIndicators() {
      var selectedColour = getSelectedColour();
      if (!selectedColour) return;
      var colourBases = stockMap[selectedColour] || {};
      var baseInputs = baseFieldset.querySelectorAll('.variant-input');

      baseInputs.forEach(function(inputDiv) {
        var input = inputDiv.querySelector('input[type="radio"]');
        if (!input) return;
        var baseValue = input.value;

        // Remove existing badge if any
        var existingBadge = inputDiv.querySelector('.' + BADGE_CLASS);
        if (existingBadge) existingBadge.remove();

        // Check if this base exists for the selected colour
        var exists = baseValue in colourBases;
        if (!exists) {
          // Hide the button entirely — this colour+base combo doesn't exist
          inputDiv.style.display = 'none';
          return;
        }

        // Show the button
        inputDiv.style.display = '';
        var qty = colourBases[baseValue];

        var isExplicit = explicitVariant && explicitVariant.option1 === selectedColour && explicitVariant.option2 === baseValue;
        if (hideOos && qty <= 0 && !isExplicit) {
          // In hide-OOS mode: hide out-of-stock base options entirely
          inputDiv.style.display = 'none';
        } else if (!hideOos) {
          // In normal mode: show Pre-order / Available badge
          var badge = document.createElement('span');
          badge.className = BADGE_CLASS;
          if (qty <= 0) {
            badge.textContent = PREORDER_TEXT;
            badge.classList.add(BADGE_CLASS + '--preorder');
          } else {
            badge.textContent = AVAILABLE_TEXT;
            badge.classList.add(BADGE_CLASS + '--available');
          }
          inputDiv.appendChild(badge);
        }
        // In hide-OOS mode with qty > 0: just show the button, no badge needed
      });

      // After updating base options, if the currently selected base is now hidden,
      // auto-select the first visible base
      if (hideOos) {
        var checkedBase = baseFieldset.querySelector('input[type="radio"]:checked');
        var checkedParent = checkedBase ? checkedBase.closest('.variant-input') : null;
        if (!checkedParent || checkedParent.style.display === 'none') {
          // Find first visible base and click it
          var firstVisible = baseFieldset.querySelector('.variant-input:not([style*="display: none"]) label');
          if (firstVisible) {
            firstVisible.click();
          } else {
            var firstVisibleInput = baseFieldset.querySelector('.variant-input:not([style*="display: none"]) input[type="radio"]');
            if (firstVisibleInput) {
              firstVisibleInput.checked = true;
              firstVisibleInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      }
    }

    // Listen for colour changes
    colourFieldset.addEventListener('change', function() {
      setTimeout(updateBaseIndicators, 50);
    });

    // Also listen for clicks on colour swatches (for image-based swatches)
    colourFieldset.addEventListener('click', function(e) {
      if (e.target.classList.contains('color-swatch') ||
          e.target.classList.contains('variant__button-label') ||
          e.target.closest('.variant-input')) {
        setTimeout(updateBaseIndicators, 100);
      }
    });

    // Run on initial load:
    // 1. Hide OOS colours first
    // 2. Auto-select first in-stock colour if default is OOS
    // 3. Update base indicators for the (now correct) selected colour
    updateColourVisibility();
    autoSelectFirstInStockColour();
    // Small delay to let Shopify's own variant JS process the colour click above
    setTimeout(function() {
      updateBaseIndicators();
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
